import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { AnimatedTextHeader } from '_ui-core-js/React/components/AnimatedTextHeader.jsx';
import { GalleryGrid } from '_ui-core-js/React/components/GalleryGrid.jsx';
import { VIEWS } from './AiExperience.jsx';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities//fireGTMTrackingEvent.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

export function LandingScreen(props) {

  const { block, data, state } = props;
  const { title, subtitle, copy, images, cta } = data;

  useEffect(() => {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.workflowEvent,
      componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience, 
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: CORE_GTM_TRACKING_VALUES.action.workflowStep,
      label: CORE_GTM_TRACKING_VALUES.label.startScreen
    }, {
      workflow: {
        name: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience,
        step: CORE_GTM_TRACKING_VALUES.label.startScreen,
        conversion: 0
      }
    });
  }, []);

  return (
    <div className={`${block}__landing-screen ${block}__layout--vertical`}>
      <div className={`${block}__landing-heading-container container-xxxl`}>
        <AnimatedTextHeader 
        heading={title}
        subheading={subtitle}
        copy={copy}
        headingClasses='headline-var-1 apply-lbx-theme-text'
        copyClasses='body'
        subheadingExpandedWidth={true}
        />  
      </div>
      <div className={`${block}__landing-image-grid-container`}>
        <GalleryGrid 
        images={images} 
        useImageAspectRatio={false} 
        />
      </div>
      <CssAnimation 
      enter={{name: 'scale-up-0-1', duration: 1.25, delay: '0.75, hidden'}}
      triggerEnter={true}
      >
        <button 
        className={`${block}__landing-start-button apply-lbx-theme-background cta`}
        onClick={() => {
          state.setActiveView(VIEWS.login.name)

          fireGTMTrackingEvent({
            name: CORE_GTM_TRACKING_VALUES.name.ctaEvent,
            componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience, 
            componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
            action: CORE_GTM_TRACKING_VALUES.action.clickCta,
            label: CORE_GTM_TRACKING_VALUES.label.startExperience,
          });
        }}
        >
          <CssAnimation 
          enter={{name: 'fade-in', duration: 0.75, delay: '1.75, hidden'}}
          triggerEnter={true}
          >
            <span>{cta.label}</span>
          </CssAnimation>
        </button>
      </CssAnimation>
    </div>
  )
};

LandingScreen.propTypes = {
  block: propTypes.string.isRequired,
  state: propTypes.object.isRequired,
  data: propTypes.object.isRequired
};
